import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from "@angular/router";

import {CheckoutSteps} from "../../../../common";
import {AppService, Cart, CartService} from "../../../../common";

@Component({
  selector: 'next-step-button',
  standalone: false,
  template: `
    <button class="btn btn-warning" (click)="onClick($event)" [disabled]="!getEnabled()">
      <!--
      <div *ngIf="step == CheckoutSteps.chooseMethod">
        <span i18n="Checkout Action Button">Choose Method</span>&nbsp;<i class="fa fa-arrow-circle-right"></i>
      </div>
      <div *ngIf="step == CheckoutSteps.choosePayment">
        <span i18n="Checkout Action Button">Payment</span>&nbsp;<i class="fa fa-arrow-circle-right"></i>
      </div>
      <div *ngIf="step == CheckoutSteps.enterContact">
        <span i18n="Checkout Action Button">Contact Data</span>&nbsp;<i class="fa fa-arrow-circle-right"></i>
      </div>
      <div *ngIf="step == CheckoutSteps.chooseTime">
        <span i18n="Checkout Action Button">Time</span>&nbsp;<i class="fa fa-arrow-circle-right"></i>
      </div>
      <div *ngIf="step == CheckoutSteps.selectBenefit">
        <i class="fas fa-hand-point-up"></i>&nbsp;<span i18n="Checkout Action Button">Select free item</span>
      </div>
      -->
      <div *ngIf="step != CheckoutSteps.submitOrder && step != CheckoutSteps.submitDemo">
        <span i18n="Checkout Action Button">Proceed</span>&nbsp;<i class="far fa-arrow-alt-circle-right"></i>
      </div>
      <div *ngIf="step == CheckoutSteps.submitOrder || step == CheckoutSteps.submitDemo">
        <i class="fas fa-paper-plane"></i>&nbsp;<span i18n="Checkout Action Button">Send Order</span>
      </div>
    </button>
  `
})

export class NextStepButton {
  @Input() cart: Cart;
  @Input() step: CheckoutSteps;
  @Input() enabled: boolean;
  @Output() next = new EventEmitter();
  // make the enum available in template
  CheckoutSteps = CheckoutSteps;

  constructor(
    private appService: AppService,
    private cartService: CartService,
    private router: Router,
  ) {}

  getEnabled() {
    if (this.step == CheckoutSteps.submitOrder || this.step == CheckoutSteps.submitDemo) {
      return this.enabled && this.cart;
    } else {
      return this.enabled;
    }
  }

  async onClick($event) {
    if (this.step == CheckoutSteps.submitOrder) {
      if (await this.cart.validate()) {   // TODO: probably unecessary
        // we are done, submit to backend
        this.cartService.sendOrder(this.cart).toPromise()
          .then(
            result => {
              if (result && result.redirect) {
                this.appService.setLoading(true);
                top.location.href = result.redirect;
              } else {
                this.router.navigate(['/', 'cash', result.orderId, 'success'])
              }
            })
          .catch((err) => {
              this.router.navigate(['/', 'error'])
            }
          );
      } else {
        this.router.navigate(['/', 'checkout'])
      }
    } else {
      // let parent component handle next step
      this.next.emit($event);
    }

    return false;
  }

}
